import styled, { css, keyframes } from 'styled-components';

const rotate = keyframes`
  0% { --angle: 0deg; }
  100% { --angle: 360deg; }
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: ${({ $borderRadius }) => $borderRadius}px;

  ${({ $disabled }) =>
    !$disabled &&
    css`
      &::before,
      &::after {
        content: '';
        position: absolute;
        top: calc(-1 * ${({ $borderWidth }) => $borderWidth}px);
        left: calc(-1 * ${({ $borderWidth }) => $borderWidth}px);
        right: calc(-1 * ${({ $borderWidth }) => $borderWidth}px);
        bottom: calc(-1 * ${({ $borderWidth }) => $borderWidth}px);
        border-radius: ${({ $borderRadius }) => $borderRadius}px;
        z-index: -1;
        pointer-events: none;
      }

      &::before {
        background: repeating-conic-gradient(
          from var(--angle),
          ${({ $colors }) => $colors.join(', ')}
        );
        animation: ${rotate} ${({ $speed }) => $speed}s linear infinite;
      }

      &::after {
        background: repeating-conic-gradient(
          from var(--angle),
          ${({ $colors }) => $colors.join(', ')}
        );
        filter: blur(${({ $blur }) => $blur}px);
        opacity: 0.75;
        animation: ${rotate} ${({ $speed }) => $speed}s linear infinite;
      }
    `}

  & > * {
    position: relative;
    z-index: 0;
  }
`;

export const Background = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border-radius: ${({ $borderRadius }) => $borderRadius}px;
  overflow: hidden;
`;
